export const currencyLocaleMapping = {
    'USD': 'us',
    'ES': 'es-ES',
    'JPY': 'ja-JP',
    'KRW': 'ko',
    'BRL': 'pt',
    'VND': 'vi',
    'Rp': 'Rp',
  };
